import React from 'react';
import DatePicker from 'react-multi-date-picker';

import { Form } from 'antd';
import { Input, Select } from 'antd';

import AgencyDepartmentSelector from '@components/AgencyDepartmentSelector/AgencyDepartmentSelector';
import BookerSelector from '@components/BookerSelector/BookerSelector';
import CitySelector from '@components/CitySelector/CitySelector';
import CitySelectorMulti from '@components/CitySelectorMulti/CitySelectorMulti';
import ContactDropdown from '@components/ContactDropdown/ContactDropdown';
import CheckDatePeriodPicker from '@components/EventDatesPicker/CheckDatePeriodPicker';
import EventDatesPicker from '@components/EventDatesPicker/EventDatesPicker';
import EventPeriodPicker from '@components/EventDatesPicker/EventPeriodPicker';
import LongEventPeriodPicker from '@components/EventDatesPicker/LongEventPeriodPicker';
import MultipleDateSelector from '@components/EventDatesPicker/MultipleDateSelector';
import RecurrenceSelector from '@components/EventDatesPicker/RecurrenceSelector';
import DisableDatePicker from '@components/EventDateTimePicker/DisableDatePicker';
import EventDateTimePicker from '@components/EventDateTimePicker/EventDateTimePicker';
import FilterDateInput from '@components/Filters/FilterDateInput';
import FilterPeriodInput from '@components/Filters/FilterPeriodInput';
import GoogleCities from '@components/GoogleCities/GoogleCities';
import CustomSwitch from '@components/Gui/CustomSwitch';
import DepartmentSelector from '@components/Gui/DepartmentSelector';
import DepartmentSelectorAccountingGroup from '@components/Gui/DepartmentSelectorAccountingGroup';
import AccountCodeSelector from '@components/Gui/NwForm/AccountCodeSelector';
import AddressForm from '@components/Gui/NwForm/AddressForm';
import AddressSelector from '@components/Gui/NwForm/AddressSelector';
import { AgencyTypeSelector } from '@components/Gui/NwForm/AgencyTypeSelector';
import AreaSelector from '@components/Gui/NwForm/AreaSelector';
import BankAccountsSelector from '@components/Gui/NwForm/BankAccountsSelector';
import BooleanSelector from '@components/Gui/NwForm/BooleanSelector';
import CategorySelect from '@components/Gui/NwForm/CategorySelect';
import Checkbox from '@components/Gui/NwForm/Checkbox';
import ChoicesSelector from '@components/Gui/NwForm/ChoicesSelector';
import ColorPicker from '@components/Gui/NwForm/ColorPicker';
import ContactWithBillingInfo from '@components/Gui/NwForm/ContactWithBillingInfo';
import ConversionSelector from '@components/Gui/NwForm/ConversionSelector';
import CurrencyRange from '@components/Gui/NwForm/CurrencyRange';
import CustomDatePicker from '@components/Gui/NwForm/CustomDatePicker';
import CustomSelect from '@components/Gui/NwForm/CustomSelect';
import DateRangePicker from '@components/Gui/NwForm/DateRangePicker';
import DocumentFilterSelector from '@components/Gui/NwForm/DocumentFilterSelector';
import EmptyDateInput from '@components/Gui/NwForm/EmptyDateInput';
import EventTypeSelector from '@components/Gui/NwForm/EventTypeSelector';
import FamilySelector from '@components/Gui/NwForm/FamilySelector';
import FeaturesBool from '@components/Gui/NwForm/FeaturesBool';
import FeaturesChoice from '@components/Gui/NwForm/FeaturesChoice';
import FeaturesMultichoice from '@components/Gui/NwForm/FeaturesMultichoice';
import FeaturesRangeSlider from '@components/Gui/NwForm/FeaturesRangeSlider';
import FeaturesTrans from '@components/Gui/NwForm/FeaturesTrans';
import FilterEventsOnSubTypes from '@components/Gui/NwForm/FilterEventsOnSubTypes';
import FilterEventsOnSubTypesAndOptionNumber from '@components/Gui/NwForm/FilterEventsOnSubTypesAndOptionNumber';
import FilterFollowUpsOnLabels from '@components/Gui/NwForm/FilterFollowUpsOnLabels';
import FilterTravelsOnTransportTypes from '@components/Gui/NwForm/FilterTravelsOnTransportTypes';
import FilterYesNoAllSelector from '@components/Gui/NwForm/FilterTypeSelector';
import FollowUpLabel from '@components/Gui/NwForm/FollowUpLabel';
import {
    FormInput,
    FormInputNumber,
    FormAutoComplete,
    FormTextAreaAutocomplete,
    FormTimePicker,
    FormRangePicker,
    FormTextArea,
} from '@components/Gui/NwForm/FormInputs';
import { GenderSelector } from '@components/Gui/NwForm/GenderSelector';
import InputTag from '@components/Gui/NwForm/InputTag';
import InputTransaction from '@components/Gui/NwForm/InputTransaction';
import InTownSelector from '@components/Gui/NwForm/InTownSelector';
import LabelSelector from '@components/Gui/NwForm/LabelSelector';
import LocationDateSelector from '@components/Gui/NwForm/LocationDateSelector';
import LocationSelector from '@components/Gui/NwForm/LocationSelector/LocationSelector';
import ModelAgencyTypeSelector from '@components/Gui/NwForm/ModelAgencyTypeSelector';
import ModelInvoiceTypeSelector from '@components/Gui/NwForm/ModelInvoiceTypeSelector';
import ModelPlayListSelector from '@components/Gui/NwForm/ModelPlayListSelector';
import MultiChoice from '@components/Gui/NwForm/MultiChoices';
import MultiInput from '@components/Gui/NwForm/MultiInput';
import MultiSelect from '@components/Gui/NwForm/MultiSelect';
import NumericRangeSelector from '@components/Gui/NwForm/NumericRangeSelector';
import NwFieldAddOnBefore from '@components/Gui/NwForm/NwFieldAddOnBefore';
import PackageDateTypeSelector from '@components/Gui/NwForm/PackageDateTypeSelector';
import PaymentStatusSelector from '@components/Gui/NwForm/PaymentStatusSelector';
import PaymentTermSelector from '@components/Gui/NwForm/PaymentTermSelector';
import PeriodSelector from '@components/Gui/NwForm/PeriodSelector';
import PrioritySelector from '@components/Gui/NwForm/PrioritySelector';
import PrivacyLevelSelector from '@components/Gui/NwForm/PrivacyLevelSelector';
import QuantitySelector from '@components/Gui/NwForm/QuantitySelector';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';
import RateTypeSelector from '@components/Gui/NwForm/RateTypeSelector';
import Rating from '@components/Gui/NwForm/Rating';
import RatingSelector from '@components/Gui/NwForm/RatingSelector';
import SelectCountry from '@components/Gui/NwForm/SelectCountry';
import SelectCountryMulti from '@components/Gui/NwForm/SelectCountryMulti';
import SelectTransport from '@components/Gui/NwForm/SelectTransport';
import StatementContactSelector from '@components/Gui/NwForm/StatementContactSelector';
import StatusSelector from '@components/Gui/NwForm/StatusSelector';
import SwatchPicker from '@components/Gui/NwForm/SwatchPicker';
import TaxSelector from '@components/Gui/NwForm/TaxSelector';
import TransactionFilter from '@components/Gui/NwForm/TransactionFilter';
import TransactionStatusSelector from '@components/Gui/NwForm/TransactionStatusSelector';
import VatSelector from '@components/Gui/NwForm/VatSelector';
import VisibilitySelector from '@components/Gui/NwForm/VisibilitySelector';
import WithCharCounter from '@components/Gui/WithCharCounter';
import ProjectSelector from '@components/ProjectSelector/ProjectSelector';
import BookingEventSelectorForTransactions from '@components/Transactions/TransactionsCreateForms/Common/BookingEventSelectorForTransactions';
import NonBookingEventSelectorForTransactions from '@components/Transactions/TransactionsCreateForms/Common/NonBookingEventSelectorForTransactions';

import AmountInput from './AmountInput';
import BirthDatePicker from './BirthDatePicker';
import ContactWithBillingInfoExtended from './ContactWithBillingInfoExtended';
import CustomerTypeSelector from './CustomerTypeSelector';
import SignatureSelector from './SignatureSelector';

const FormItem = Form.Item;
const { Option } = Select;
const TextAreaWithCharCounter = WithCharCounter(FormTextArea);

const CreateNWField =
    (AntComponent) =>
    ({
        field,
        form,
        hasFeedback = true,
        label,
        extra,
        inlineLabel,
        selectOptions,
        submitCount,
        type,
        autoCompleteSuggestions,
        onAfterChange,
        onAfterBlur,
        manipulateValue,
        innerRef,
        addOnBefore,
        required,
        ...props
    }) => {
        const touched = form.touched[field.name];

        const submitted = submitCount > 0;

        const hasError = form.errors[field.name];

        const submittedError = hasError && submitted;

        const touchedError = hasError && touched;

        // alcuni validator (gli indirizzi) ritornano un oggetto di errori per sottocampo: in quel
        // caso il FormItem esterno resta neutro, altrimenti antd colorerebbe di rosso tutti i
        // campi contenuti, e l'oggetto viene passato al componente che sa a chi appartengono
        const showError = Boolean(submittedError || touchedError);
        const fieldErrors = showError && typeof hasError === 'object' ? hasError : null;
        const helpError = showError && !fieldErrors ? hasError : false;

        const onInputChange = (evOrValue) => {
            // Support both event (typing) and raw value (e.g. AutoComplete selection)
            const value =
                evOrValue != null && typeof evOrValue === 'object' && evOrValue.target != null
                    ? evOrValue.target.value
                    : evOrValue;
            form.setFieldValue(field.name, value);
            //form.setFieldTouched(field.name, true);
            if (onAfterChange) onAfterChange(value);
        };

        const onChange = (value) => {
            let _value = manipulateValue ? manipulateValue(value) : value;
            form.setFieldValue(field.name, _value);
            //form.setFieldTouched(field.name, true);
            if (onAfterChange) onAfterChange(_value);
        };

        const onBlur = () => {
            form.setFieldTouched(field.name, true);
            if (onAfterBlur) onAfterBlur(field.value);
        };

        const GetFormItemContainerClassName = () => {
            let cn = 'nw-form-item-container';
            if (inlineLabel) {
                cn += ' inline';
            }
            return cn;
        };
        return (
            <div className={GetFormItemContainerClassName()}>
                <FormItem
                    colon={false}
                    label={label}
                    extra={extra}
                    className
                    required={required}
                    help={helpError}
                    validateStatus={helpError ? 'error' : 'success'}
                >
                    <NwFieldAddOnBefore addOnBefore={addOnBefore}>
                        <AntComponent
                            {...field}
                            {...props}
                            {...(fieldErrors ? { fieldErrors } : {})}
                            ref={innerRef}
                            onChange={type ? onInputChange : onChange}
                            onBlur={onBlur}
                        >
                            {selectOptions &&
                                selectOptions.map((opt) => (
                                    <Option key={opt.key} value={opt.value} /*title={opt.label}*/>
                                        {opt.label}
                                    </Option>
                                ))}
                        </AntComponent>
                    </NwFieldAddOnBefore>
                </FormItem>
            </div>
        );
    };

export const NWSelect = CreateNWField(CustomSelect);
export const NWPassword = CreateNWField(Input.Password);
export const NWTimePicker = CreateNWField(FormTimePicker);
export const NWGenderSelector = CreateNWField(GenderSelector);
export const NWContactDropdown = CreateNWField(ContactDropdown);
export const NWAgencyTypeSelector = CreateNWField(AgencyTypeSelector);
export const NWInputNumber = CreateNWField(FormInputNumber);
export const NWDatePicker = CreateNWField(CustomDatePicker);
export const NWMultiDatePicker = CreateNWField(DatePicker);
export const NWSwitch = CreateNWField(CustomSwitch);
export const NWCheckbox = CreateNWField(Checkbox);
export const NWInput = CreateNWField(FormInput);
export const NWSelectCountry = CreateNWField(SelectCountry);
export const NWSelectCountryMulti = CreateNWField(SelectCountryMulti);
export const NWCitySelector = CreateNWField(CitySelector);
export const NWCitySelectorMulti = CreateNWField(CitySelectorMulti);
export const NWTextAreaCharCounter = CreateNWField(TextAreaWithCharCounter);
export const NWTextAreaAutoComplete = CreateNWField(FormTextAreaAutocomplete);
export const NWAutoComplete = CreateNWField(FormAutoComplete);
export const NWFilterDateInput = CreateNWField(FilterDateInput);
export const NWFilterPeriodInput = CreateNWField(FilterPeriodInput);
export const NWEmptyDateInput = CreateNWField(EmptyDateInput);
export const NWBookerSelector = CreateNWField(BookerSelector);
export const NWAmountInput = CreateNWField(AmountInput);
export const NWQuantitySelector = CreateNWField(QuantitySelector);
export const NWInputTag = CreateNWField(InputTag);
export const NWInputTransaction = CreateNWField(InputTransaction);
export const NWCategorySelect = CreateNWField(CategorySelect);
export const NWCurrencyRange = CreateNWField(CurrencyRange);
export const NWBooleanSelector = CreateNWField(BooleanSelector);
export const NWDepartmentSelector = CreateNWField(DepartmentSelector);
export const NWDepartmentSelectorAccountingGroup = CreateNWField(DepartmentSelectorAccountingGroup);
export const NWFeaturesRangeSlider = CreateNWField(FeaturesRangeSlider);
export const NWNumericRangeSelector = CreateNWField(NumericRangeSelector);
export const NWFeaturesMultichoice = CreateNWField(FeaturesMultichoice);
export const NWFeaturesChoice = CreateNWField(FeaturesChoice);
export const NWFeaturesTrans = CreateNWField(FeaturesTrans);
export const NWFeaturesBool = CreateNWField(FeaturesBool);
export const NWInTownSelector = CreateNWField(InTownSelector);
export const NWProjectSelector = CreateNWField(ProjectSelector);
export const NWModelInvoiceTypeSelector = CreateNWField(ModelInvoiceTypeSelector);
export const NWModelAgencyTypeSelector = CreateNWField(ModelAgencyTypeSelector);
export const NWColorPicker = CreateNWField(ColorPicker);
export const NWMultiSelect = CreateNWField(MultiSelect);
export const NWSelectTransport = CreateNWField(SelectTransport);
export const NWRatingSelector = CreateNWField(RatingSelector);
export const NWRate = CreateNWField(Rating);
export const NWFollowUpLabel = CreateNWField(FollowUpLabel);
export const NWEventDateTimePicker = CreateNWField(EventDateTimePicker);
export const NWPrivacyLevelSelector = CreateNWField(PrivacyLevelSelector);
export const NWBirthDatePicker = CreateNWField(BirthDatePicker);
export const NWEventTypeSelector = CreateNWField(EventTypeSelector);
export const NWAddressSelector = CreateNWField(AddressSelector);
export const NWAgencyDepartmentSelector = CreateNWField(AgencyDepartmentSelector);
export const NWRateTypeSelector = CreateNWField(RateTypeSelector);
export const NWFilterYesNoAllSelector = CreateNWField(FilterYesNoAllSelector);
export const NWAreaSelector = CreateNWField(AreaSelector);
export const NWGoogleCities = CreateNWField(GoogleCities);
export const NWRangePicker = CreateNWField(FormRangePicker);
export const NWVisibilitySelector = CreateNWField(VisibilitySelector);
export const NWRadioButtonGroup = CreateNWField(RadioButtonGroup);
export const NWDisableDatePicker = CreateNWField(DisableDatePicker);
export const NWSwatchPicker = CreateNWField(SwatchPicker);
export const NWPrioritySelector = CreateNWField(PrioritySelector);
export const NWLocationDateSelector = CreateNWField(LocationDateSelector);
export const NWPeriodSelector = CreateNWField(PeriodSelector);
export const NWChoicesSelector = CreateNWField(ChoicesSelector);
export const NWEventDatesPicker = CreateNWField(EventDatesPicker);
export const NWEventPeriodPicker = CreateNWField(EventPeriodPicker);
export const NWLongEventPeriodPicker = CreateNWField(LongEventPeriodPicker);
export const NWMultipleDateSelector = CreateNWField(MultipleDateSelector);
export const NWRecurrenceSelector = CreateNWField(RecurrenceSelector);
export const NWCheckDatePeriodPicker = CreateNWField(CheckDatePeriodPicker);
export const NWMultiInput = CreateNWField(MultiInput);
export const NWMultiChoice = CreateNWField(MultiChoice);
export const NWConversionSelector = CreateNWField(ConversionSelector);
export const NWAddressForm = CreateNWField(AddressForm);
export const NWDateRangePicker = CreateNWField(DateRangePicker);
export const NWLocationSelector = CreateNWField(LocationSelector);
export const NWTransactionFilter = CreateNWField(TransactionFilter);
export const NWPaymentTermSelector = CreateNWField(PaymentTermSelector);
export const NWBankAccountsSelector = CreateNWField(BankAccountsSelector);
export const NWPaymentStatusSelector = CreateNWField(PaymentStatusSelector);
export const NWStatementContactSelector = CreateNWField(StatementContactSelector);
export const NWTransactionStatusSelector = CreateNWField(TransactionStatusSelector);
export const NWFamilySelector = CreateNWField(FamilySelector);
export const NWLabelSelector = CreateNWField(LabelSelector);
export const NWTaxSelector = CreateNWField(TaxSelector);
export const NWVatSelector = CreateNWField(VatSelector);
export const NWStatusSelector = CreateNWField(StatusSelector);
export const NWPackageDateTypeSelector = CreateNWField(PackageDateTypeSelector);
export const NWModelPlayListSelector = CreateNWField(ModelPlayListSelector);
export const NWDocumentFilterSelector = CreateNWField(DocumentFilterSelector);
export const NWContactWithBillingInfo = CreateNWField(ContactWithBillingInfo);
export const NWContactWithBillingInfoExtended = CreateNWField(ContactWithBillingInfoExtended);
export const NWNonBookingEventSelectorForTransactions = CreateNWField(NonBookingEventSelectorForTransactions);
export const NWBookingEventSelectorForTransactions = CreateNWField(BookingEventSelectorForTransactions);
export const NWFilterFollowUpsOnLabels = CreateNWField(FilterFollowUpsOnLabels);
export const NWFilterEventsOnSubTypes = CreateNWField(FilterEventsOnSubTypes);
export const NWFilterEventsOnSubTypesAndOptionNumber = CreateNWField(FilterEventsOnSubTypesAndOptionNumber);
export const NWFilterTravelsOnTransportTypes = CreateNWField(FilterTravelsOnTransportTypes);
export const NWSignatureSelector = CreateNWField(SignatureSelector);
export const NWCustomerTypeSelector = CreateNWField(CustomerTypeSelector);
export const NWAccountCodeSelector = CreateNWField(AccountCodeSelector);
